import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { DECEASED_REACTIVATE_CONFIRM } from '../utils/deactivationReasons';

const MIN_REASON = 3;

// Confirm dialog for the audited Reactivate action; a reason is required and stored in the audit log.
// A patient marked deceased: only Super Admin (canOverrideDeceased) may reactivate, after an explicit confirmation.
const ReactivatePatientModal = ({
    show,
    patientName,
    onCancel,
    onConfirm,
    submitting = false,
    deceased = false,
    canOverrideDeceased = false,
}) => {
    const [reason, setReason] = useState('');
    const [confirmDeceased, setConfirmDeceased] = useState(false);

    useEffect(() => {
        if (show) {
            setReason('');
            setConfirmDeceased(false);
        }
    }, [show]);

    const blockedDeceased = deceased && !canOverrideDeceased;
    const valid = reason.trim().length >= MIN_REASON && !blockedDeceased && (!deceased || confirmDeceased);

    return (
        <Modal size="sm" show={show} onHide={onCancel} aria-labelledby="reactivate-patient-title">
            <Modal.Header closeButton>
                <Modal.Title id="reactivate-patient-title" as="h6">Reactivate patient</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {deceased && (
                    <div className="alert alert-danger py-2" role="alert" style={{ fontSize: '13px' }}>
                        <strong>Deceased.</strong>{' '}
                        {blockedDeceased
                            ? 'This patient is marked deceased. Only a Super Admin can reactivate.'
                            : 'This patient is marked deceased.'}
                    </div>
                )}
                <small style={{ color: 'gray' }}>
                    Reactivate <span style={{ color: '#000' }}>{patientName}</span>? The patient returns to the active
                    lists and dashboard counts. This action is recorded in the audit log.
                </small>
                <label htmlFor="reactivate-reason" className="mt-2" style={{ fontSize: '13px' }}>Reason (required)</label>
                <textarea
                    id="reactivate-reason"
                    className="form-control"
                    rows={3}
                    maxLength={500}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
                {deceased && canOverrideDeceased && (
                    <div className="form-check mt-2">
                        <input
                            id="reactivate-deceased-confirm"
                            type="checkbox"
                            className="form-check-input"
                            checked={confirmDeceased}
                            onChange={(e) => setConfirmDeceased(e.target.checked)}
                        />
                        <label htmlFor="reactivate-deceased-confirm" className="form-check-label" style={{ fontSize: '13px' }}>
                            {DECEASED_REACTIVATE_CONFIRM} Yes, reactivate.
                        </label>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-sm btn-secondary" onClick={onCancel}>Cancel</button>
                <button
                    type="button"
                    className="btn btn-sm btn-success"
                    disabled={!valid || submitting}
                    onClick={() => (deceased ? onConfirm(reason.trim(), confirmDeceased) : onConfirm(reason.trim()))}
                >
                    Reactivate
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default ReactivatePatientModal;
